import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

/**
 *
 * @param {string} _
 * @param {import('modules/statistics/types').FetchRefreshTimeSuccessAction} action
 * @returns {string}
 */
const setValue = (_, { payload }) => payload.timestamp;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_LATEST_REFRESH_SUCCESS]: setValue,
  [types.FETCH_LATEST_REFRESH_FAILURE]: reset,
});
